import React from "react";
import { Button, Flex, ModalV2, Text, toast } from "@jsq/ds/core";
import { client } from "~/apollo/client";
import { useCancelComplianceInvitationMutation } from "~/graphql/supergraphHooks";
import {
  cancelRemediationModalBody,
  cancelRemediationModalHeader,
  cancelRemediationModalSubtitle,
} from "./styles_vanilla.css";

export type CancelRemediationModalProps = {
  show: boolean;
  onHide: () => void;
  positionName: string;
  entityName: string;
  invitationId: number;
};

const CancelRemediationModal: React.FC<CancelRemediationModalProps> = ({
  show,
  onHide,
  positionName,
  entityName,
  invitationId,
}) => {
  const [cancelComplianceInvitation, { loading }] = useCancelComplianceInvitationMutation({
    variables: {
      invitationId,
    },
    onCompleted: () => {
      void client.refetchQueries({
        include: "active",
      });
    },
  });

  const handleCancelInvitation = async () => {
    try {
      await cancelComplianceInvitation();
      toast.success("Invitation cancelled successfully");
      onHide();
    } catch {
      toast.error("Failed to cancel invitation");
    }
  };

  return (
    <ModalV2
      show={show}
      onHide={onHide}
      title="Cancel remediation request"
      headerClassName={cancelRemediationModalHeader}
      size="small"
    >
      <ModalV2.Body>
        <Text variant="regular-md" className={cancelRemediationModalSubtitle}>
          {`${positionName} in ${entityName}`}
        </Text>
        <Text variant="regular-md" className={cancelRemediationModalBody}>
          The URL that was sent to the selected portal accounts will be cancelled.
        </Text>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex justifyContent="flex-end" gap="12px">
          <Button variant="neutral" onClick={onHide} data-testid="cancel-modal-button">
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleCancelInvitation}
            data-testid="cancel-invitation-button"
            isLoading={loading}
          >
            Cancel request
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};

export default CancelRemediationModal;
